import { Container, Nav, Navbar } from "react-bootstrap";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../components/auth/AuthContext";
import FillView from "../components/fillView/FillView";
import { CurrentUser } from "../types/User";

const AdminLayout = () => {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState<CurrentUser | undefined>(authContext?.user);

  useEffect(() => {
    setUser(authContext?.user);
  }, [authContext?.user]);

  useEffect(() => {
    if (
      !user &&
      location.pathname.toLowerCase() !== "/admin/login" &&
      location.pathname.toLowerCase() !== "/admin/forgottenpassword"
    ) {
      navigate("/admin/login");
    }
  }, [user, navigate, location]);

  return (
    <FillView>
      <Navbar expand="lg" bg="secondary" data-bs-theme="dark">
        <Container fluid={true}>
          <Navbar.Brand href="/Admin">
            <img
              src="/plusbus-logo.png"
              height="30"
              className="d-inline-block align-top"
              alt="PlusBus"
            />{" "}
            Admin
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              {user && (
                <>
                  <Nav.Link
                    href="#"
                    onClick={() => {
                      navigate("/admin/exports");
                    }}
                  >
                    Data Exports
                  </Nav.Link>
                  <Nav.Link
                    href="#"
                    onClick={() => {
                      authContext?.logout();
                      navigate("/admin/login");
                    }}
                  >
                    Logout
                  </Nav.Link>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Outlet />
    </FillView>
  );
};

export default AdminLayout;
